import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { QuickSearch } from 'screens/Team/Rabbit/Goals/AgGridTreeView/QuickSearch';

import { isMobileView } from 'constants/isMobileView';

export const ParentOKRSelectionHeader = ({ gridRef }) => (
  <Flex alignItems="center" justifyContent="space-between" px={2} py={isMobileView() ? 1 : 3}>
    <Box flex={1} minW="180px">
      <QuickSearch gridRef={gridRef} selectedCohort={null} placeholder="Search Goals" maxWidth="100%" isV2 />
    </Box>
  </Flex>
);
